import { Component, OnDestroy, OnInit, Input, HostListener, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

// Services
import { ApiAuthService } from '@services/api-auth.service';
import { SharedService } from '@services/shared.service';

import { CustomerModel } from '@models/CustomerModel';

import * as $ from 'jquery';
import { SweetAlertResult } from 'sweetalert2';
import { Country } from '@shared/models/Enums';


@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit, OnDestroy {

    @Input() isSinglePage = false;
    @Input() isDesktop = false;
    @Input() isApp = true;

    logo = `assets/images/logo-givi.png`;
    isCustomLogo = false;
    showNav = true;
    showHamburgerMenu = true;
    showIconsMenu = true;

    profile: CustomerModel;

    hideLogin = false;
    
    isGiviScanApp: boolean= false;
    gsaLogo: string;
    hideCommunitiesHeader = false; 

    showMiMenu = false;

    private clickCount = 0;

    private accountSubscription: Subscription = null;
    private logoutSubscription: Subscription = null;
    private hideLoginSubscription: Subscription = null;
    private hideNavSubscription: Subscription = null;
    private hideHamburgerMenuSubscription: Subscription = null;
    private showMenuSubscription: Subscription = null;

    private isMarketSubscription: Subscription = null;

    constructor(private router: Router,
        public sharedService: SharedService,
        private apiAuthService: ApiAuthService,
        private cdr: ChangeDetectorRef) {
    }

    ngOnInit() {

        this.showHamburgerMenu = this.isApp ? false : true;

        this.accountSubscription = this.sharedService.accountSubject.subscribe(x => this._initProfile(x)); 
        this.sharedService.isGiviScanApp.subscribe((isGiviScan)=>this.isGiviScanApp = isGiviScan);  
        this.sharedService.gsaLogo.subscribe((gsaLogo)=> this.gsaLogo = gsaLogo);

        this.showMenuSubscription = this.sharedService.showMenu.subscribe((showMenu) => this.showMiMenu = showMenu);

        // subscribe and tracking the logout state
        this.logoutSubscription = this.sharedService.logoutSubject.subscribe(() => {

            this.apiAuthService.logout(this.router);
            this.hideLogin = true;
            this.isCustomLogo = false;
            this.showHamburgerMenu = false;
            this.showIconsMenu = false;
        });

        this.hideLoginSubscription = this.sharedService.hideLoginSubject.subscribe((hide) => {
            this.hideLogin = hide;
        });

        // hide footer and nav
        this.hideNavSubscription = this.sharedService.hideNav.subscribe((hide) => {
            this.showNav = !hide;

            this.cdr.detectChanges();        
        });

        // hide footer and nav
        this.hideHamburgerMenuSubscription = this.sharedService.hideHamburgerMenu.subscribe((hide) => {

            const urls = this.router.url.split('/').filter(x => x);
            const baseUrl = urls.length ? `/${urls.shift()}` : '';
            if (baseUrl == '/login' || baseUrl == '/registro') {

                this.showHamburgerMenu = false;
                this.showIconsMenu = false;

            } else {
                this.showHamburgerMenu = this.isApp ? false : !hide;
            }
        });

        // Check if exist stored session.
        const session = this.apiAuthService.getSession();
        if (session && session.accessToken) {

            this._initProfile(session.user);
        }

        // Controla el sidebar la primera vez que carga
        setTimeout(() => this._setResize(null), 100);

        // $(window).ready(() => setResize);
        $(window).on('resize', (ev) => this._setResize(ev));
        // Limpia los clicks
        setInterval(() => this.clickCount = 0, 2000);
    }

    ngOnDestroy() {

        if (this.showMenuSubscription) { this.showMenuSubscription.unsubscribe(); }

        if (this.logoutSubscription) { this.logoutSubscription.unsubscribe(); }

        if (this.accountSubscription) { this.accountSubscription.unsubscribe(); }

        if (this.hideLoginSubscription) { this.hideLoginSubscription.unsubscribe(); }

        if (this.hideNavSubscription) { this.hideNavSubscription.unsubscribe(); }

        if (this.hideHamburgerMenuSubscription) { this.hideHamburgerMenuSubscription.unsubscribe(); }

        if (this.isMarketSubscription) { this.isMarketSubscription.unsubscribe(); }
    }

    toggleSidebar(): void {

        if (!this.isApp) {

            const className = 'mini-sidebar';

            if ($('#main-wrapper')) {

                $('body').trigger('resize');

                if ($('#main-wrapper').hasClass(className)) {

                    // Se muestra el sidebar con el menu
                    $('#main-wrapper').removeClass(className);

                    if (!this.isDesktop) {
                        // ocultar el scrollbar si el sidebar menu esta desplegado
                        $('#main-wrapper').addClass('overflow-hidden');
                    }
                } else {

                    // Ocultar o mostrar la version mini del sidebar menu
                    $('#main-wrapper').addClass(className);

                    // Mostrar el scrollbar si el sidebar menu esta oculto
                    $('#main-wrapper').removeClass('overflow-hidden');
                }
            }
        }
    }

    onNavigateMain() { 

        const urls = this.router.url.split('/').filter(x => x);
        const baseUrl = urls.length ? `/${urls.shift()}` : '';

        if(baseUrl == '/market?action=1'){
            this.router.navigate(['/market'], { queryParams: { login: 'success', action: 1 } });
        }else{
            this.router.navigate(['/market'], { queryParams: {  action: 1 } });
        }
        
    }

    onOpenWelcome() {

        this.clickCount++;

        if (this.clickCount > 5) {

            this.router.navigate(['/bienvenido']);
            this.clickCount = 0;
        }
    }

    onGoCommunities(){

        this.router.navigate(['/communities']);
    }

    private _initProfile(user: CustomerModel) { 

        const urls = this.router.url.split('/').filter(x => x);
        const baseUrl = urls.length ? `/${urls.shift()}` : '';

        if (baseUrl == '/mimenu') this.showMiMenu = true;

        if (baseUrl == '/login') {

            this.profile = null;
            this.hideLogin = true;
        } else {

            this.profile = user;
            this.hideLogin = false;
        }

        // Refresh UI
        setTimeout(() => {

            if (this.isSinglePage && !this.profile) {

                // Solo reemplazar el logo si no esta vacio o null
                if (this.logo) { this.logo = `assets/images/logo-givi.png`; }
                this.isCustomLogo = false;
            } else {

                // this.logo = this.profile.logoURL;
                // this.isCustomLogo = true;
            }
        }, 100);
    }

    private _setResize(ev: any) {

        // Solo cambiar el sidebar menu si el tamano del window cambia
        if (!ev || !ev.target || ev.target.clientWidth != window.innerWidth) {

            if (!ev || !ev.target || (window.innerWidth - ev.target.clientWidth) > 20) {

                if (this.isSinglePage) {

                    // Ocultar o mostrar la version mini del sidebar menu
                    $('#main-wrapper').addClass('mini-sidebar');
                } else {

                    const width = (window.innerWidth > 0) ? window.innerWidth : window.screen.width;
                    if (width < 1170) {
                        // Ocultar o mostrar la version mini del sidebar menu
                        $('#main-wrapper').addClass('mini-sidebar');
                    } else {
                        $('#main-wrapper').removeClass('mini-sidebar');
                    }
                }
            }
        }
    }

    onNavigateVideos() {

        this.router.navigate(['/videos']);
    }

    onNavigateNotifications() {

        this.router.navigate(['/notificaciones']);
    }

    onNavigateMenu() {
        
        const urls = this.router.url.split('/').filter(x => x);
        const baseUrl = urls.length ? `/${urls.shift()}` : '';
        
        if (baseUrl == '/mimenu') {

            this.showMiMenu = false;
            this.router.navigate(['/market']);

        }else{ 

            this.sharedService.setIsGiViScan(false);

            this.router.navigate(['/mimenu']);
        }
    }

    onClose(){
        this.showMiMenu = false;
        window.history.back();
    }

    onNavigateGsaMenu() {

        const urls = this.router.url.split('/').filter(x => x);
        const baseUrl = urls.length ? `/${urls.shift()}` : '';
        if (baseUrl == '/gsa-menu') {
            this.router.navigate(['/gsa-dashboard']);
        }else{
            this.router.navigate(['/gsa-menu']);
        }
    }

    onNavigateBalance() {

        this.router.navigate(['/balance']);
    }

    onNavigateGivis() {

        this.showMiMenu = false;

        this.router.navigate(['/givis']);
    }
}
